module.exports = __webpack_public_path__ + "7a3a08f248ef11197159624e66f7c324.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/giant-bow-black-s.png
// module id = 2202
// module chunks = 0